import {
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
} from "@apollo/react-hooks";
import {
  Button,
  Card,
  Checkbox,
  Drawer,
  Empty,
  Form,
  List,
  message,
  Select,
  Tooltip,
} from "antd";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Loader } from "../../Components/Loader/Loader";
import { CustIcon } from "../../Components/Svgs";
import { ASSIGN_TASK } from "../../Graphql/mutations";

import Empty_EscalationVector from "../../Assets/Images/Empty/Empty_EscalationVector.svg";
import Empty_SendFirstAnnouncement from "../../Assets/Images/Empty/Empty_SendFirstAnnouncement.svg";
import TaskQrCodeModal from "../../Components/Drawers/TaskQrCode/TaskQrCodeModal";
import { TaksGuideModal } from "../../Components/Modals/TaksGuideModal";
import { UpgradePlanModal } from "../../Components/Modals/UpgradePlanModal";
import {
  GET_ALL_USERS,
  GET_LOCATION_AND_ROLES,
  GET_USER_TIMEZONE,
} from "../../Graphql/queries";
import {
  GET_AVAILABLE_PREDEFINED_TASKS_FOR_USERS,
  GET_CUSTOM_TASKS_FOR_USERS_PENDING,
  GET_USERS_ASSIGNED_TASKS,
} from "../../Graphql/subscriptions";
import { usePermissionUser } from "../../Utils/Context/permissionContext";
import "./TaskManagement.less";

const { Option } = Select;
export const TaskManagement = (props) => {
  const history = useHistory();
  const { userPermissionAccess: permission } = usePermissionUser();
  const [isSelectEmployee, setSelectEmployee] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedEmployeeData, setSelectedEmployeeData] = useState([]);
  const [checkedTaskList, setCheckedTaskList] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(undefined);
  const [allRoles, setAllRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(undefined);
  const [sortedTasks, setSortedTasks] = useState([]);
  const [userTaskId, setUserTaskId] = useState();
  const [showQrDrawer, setShowQrDrawer] = useState(false);
  const [showUpgradePlanModal, setShowUpgradePlanModal] = useState(false);
  const [showRequiredAttachment, setShowRequiredAttachment] = useState(false);
  const [isAssigningRequiredAttachment, setIsAssigningRequiredAttachment] =
    useState(false);
  const [requiredAttachmentList, setRequiredAttachmentList] = useState([]);
  const [checkedRequiredAttechTaskList, setCheckedRequiredAttechTaskList] =
    useState([]);
  const { data: filterData, loading } = useQuery(GET_LOCATION_AND_ROLES, {
    variables: {
      user_id: localStorage.getItem("user_id"),
      userAccessType:
        props.userData.getUsersById.user_access.access_id == 1
          ? "0"
          : props.userData.getUsersById.user_access.access_id,
    },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (filterData) {
      setAllLocations(filterData.locationList);
      setAllRoles(
        filterData.jobRoleList[0]?.locationDetails.user_location_maps
      );
    }
  }, [filterData]);

  const { data: userData, loading: userDataLoading } = useQuery(
    GET_USER_TIMEZONE,
    { variables: { user_id: localStorage.getItem("user_id") } }
  );
  // const [GET_TASKS_QUERY, { data: taskResp, loading: isTasksLoading }] =
  //   useLazyQuery(GET_TASKS);
  const [GET_USERS_QUERY, { data, loading: isUsersLoading }] =
    useLazyQuery(GET_ALL_USERS);
  const [ASSIGN_TASK_MUTATION, { loading: isAssigningTasks }] =
    useMutation(ASSIGN_TASK);

  useEffect(() => {
    getUsers();
  }, [selectedLocation, selectedRole]);

  const { data: roleTasks, loading: roleTasksLoading } = useSubscription(
    GET_AVAILABLE_PREDEFINED_TASKS_FOR_USERS,
    {
      variables: {
        user_id: Object.keys(selectedEmployeeData).length
          ? selectedEmployeeData.user_id
          : localStorage.getItem("user_id"),
      },
      shouldResubscribe: true,
      skip: userDataLoading || isUsersLoading,
    }
  );
  const { data: customTasksList, loading: customTasksLoading } =
    useSubscription(GET_CUSTOM_TASKS_FOR_USERS_PENDING, {
      variables: {
        user_id: Object.keys(selectedEmployeeData).length
          ? selectedEmployeeData.user_id
          : localStorage.getItem("user_id"),
        todays_date: moment()
          .tz(userData?.getUsersById?.time_zone)
          ?.format("YYYY-MM-DD"),
      },
      shouldResubscribe: true,
      skip: userDataLoading || isUsersLoading,
    });
  const { data: assignedTasks, loading: assignedTasksLoading } =
    useSubscription(GET_USERS_ASSIGNED_TASKS, {
      variables: {
        user_id:
          (Object.keys(selectedEmployeeData).length &&
            selectedEmployeeData.user_id) ||
          localStorage.getItem("user_id"),
        todays_date: moment()
          .tz(userData?.getUsersById?.time_zone)
          ?.format("YYYY-MM-DD"),
      },
      shouldResubscribe: true,
      skip: userDataLoading || isUsersLoading || !userData,
    });

  useEffect(() => {
    if (roleTasks && assignedTasks && customTasksList) {
      let assignedTask = assignedTasks.user_tasks_map.flatMap(
        ({ task, task_date }) => {
          return [task.task_id];
        }
      );
      setCheckedTaskList(assignedTask);
      setSortedTasks([
        ...roleTasks.tasks.filter(
          (p) =>
            p.task_type === "time_sensitive" && assignedTask.includes(p.task_id)
        ),
        ...roleTasks.tasks.filter(
          (p) => p.task_type === "reminder" && assignedTask.includes(p.task_id)
        ),
        ...roleTasks.tasks.filter(
          (p) =>
            p.task_type === "during_day" && assignedTask.includes(p.task_id)
        ),
        ...roleTasks.tasks.filter(
          (p) =>
            p.task_type === "end_of_day" && assignedTask.includes(p.task_id)
        ),
        ...roleTasks.tasks.filter(
          (p) =>
            p.task_type === "time_sensitive" &&
            !assignedTask.includes(p.task_id)
        ),
        ...roleTasks.tasks.filter(
          (p) => p.task_type === "reminder" && !assignedTask.includes(p.task_id)
        ),
        ...roleTasks.tasks.filter(
          (p) =>
            p.task_type === "during_day" && !assignedTask.includes(p.task_id)
        ),
        ...roleTasks.tasks.filter(
          (p) =>
            p.task_type === "end_of_day" && !assignedTask.includes(p.task_id)
        ),
      ]);
    }
  }, [roleTasks, assignedTasks, customTasksList]);

  const getUsers = () => {
    GET_USERS_QUERY({
      variables: {
        user_id: localStorage.getItem("user_id"),
        userAccessType:
          props.userData.getUsersById.user_access.access_id == "1"
            ? "0"
            : props.userData.getUsersById.user_access.access_id,
        location: selectedLocation ? selectedLocation : undefined,
        role: selectedRole ? selectedRole : undefined,
      },
    });
  };

  useEffect(() => {
    if (!data || data.length === 0) {
      getUsers();
    }
    if (data && data.userList.length > 0) {
      let empData = [];
      data.userList.map((locData) => {
        locData.locationDetails.user_location_maps.map((userData) => {
          let dataSet = {
            ...userData.userDetails,
            ...userData.jobRoleDetails,
            ...userData.locationDetails,
          };
          empData.push(dataSet);
        });
      });
      let reducedData = empData.reduce((newListOfTags, current) => {
        if (!newListOfTags.some((x) => x.user_id == current.user_id)) {
          newListOfTags.push(current);
        }
        return newListOfTags;
      }, []);
      var fromIndex = reducedData.findIndex(function (item, i) {
        return item.role_name === "Owner";
      });
      if (fromIndex !== -1) {
        var element = reducedData[fromIndex];
        reducedData.splice(fromIndex, 1);
        reducedData.splice(0, 0, element);
      }
      setEmployeeData(reducedData);
      setSelectedEmployeeData(reducedData.length > 0 ? reducedData[0] : {});
    } else {
      setEmployeeData([]);
      setSelectedEmployeeData([]);
      setCheckedTaskList([]);
    }
  }, [data]);

  const toggleSelectEmployee = () => {
    setSelectEmployee((selectEmployeeStatus) => !selectEmployeeStatus);
  };

  const toggleEmployeeTask = (data) => {
    setSelectedEmployeeData(data);
    // let selectedTasks = []
    // data.userDetails.user_tasks_maps.map((tasks,index) => {
    //  selectedTasks.push(tasks.task_id)
    // })
    //setCheckedTaskList(selectedTasks)
    // GET_TASKS_QUERY({
    //   variables: {
    //     role_id: data.role_id,
    //   },
    // });
  };

  const getNearTask = (data) => {
    const pendingTaskMaps = data.filter(({ task_date, task_status }) => {
      return (
        task_status === "pending" &&
        moment(task_date, "YYYY-MM-DD").isSameOrAfter(moment(), "day")
      );
    });
    const sortedPendingTaskMaps = pendingTaskMaps.sort(
      (a, b) =>
        moment(a.task_date).format("YYYY-MM-DD") -
        moment(b.task_date).format("YYYY-MM-DD")
    );
    return sortedPendingTaskMaps[0]?.user_task_id;
  };

  const onFinish = async () => {
    setIsAssigningRequiredAttachment(true);
    let taskData = roleTasks.tasks
      .flatMap((t) => {
        if (checkedTaskList.includes(t.task_id)) {
          return [
            {
              task_id: t.task_id,
              task_type: t.task_type,
            },
          ];
        }
      })
      .filter((a) => !!a);
    customTasksList.customTasks
      .flatMap((t) => {
        if (checkedTaskList.includes(t.task.task_id)) {
          const dt = {
            task_id: t.task.task_id,
            task_type: t.task.task_type,
            task_date: t.task_date,
          };
          taskData.push(dt);
        }
      })
      .filter((a) => !!a);
    let selectedtask = {
      user_id: selectedEmployeeData.user_id,
      tasks: taskData?.map((t) => ({
        ...t,
        required_attachment: checkedRequiredAttechTaskList.includes(t.task_id),
      })),
    };
    let response = await ASSIGN_TASK_MUTATION({
      variables: selectedtask,
    });
    if (response.data.assign_task) {
      message.success(response.data.assign_task.message);
      setIsAssigningRequiredAttachment(false);
      onCloseRequiredAttachment();
    }
  };
  const onRequiredAttachment = async () => {
    if (roleTasks) {
      let reqAttList = roleTasks.tasks
        .flatMap((t) => {
          if (checkedTaskList.includes(t.task_id)) {
            return [
              {
                task_id: t.task_id,
                task_type: t.task_type,
                type_name: t.taskTypeByTaskType.type_name,
                description: t.description,
                required_attachment: !!t.user_tasks_maps.filter(
                  (ra) => ra.required_attachment && ra.task_status === "pending"
                ).length,
              },
            ];
          }
        })
        .filter((a) => !!a);
      customTasksList.customTasks
        .flatMap((t) => {
          if (checkedTaskList.includes(t.task.task_id)) {
            const dt = {
              task_id: t.task.task_id,
              task_type: t.task.task_type,
              type_name: t.task.taskTypeByTaskType.type_name,
              description: t.task.description,
              required_attachment: t.required_attachment,
            };
            reqAttList.push(dt);
          }
        })
        .filter((a) => !!a);
      await setCheckedRequiredAttechTaskList(
        reqAttList
          .filter((ts) => ts.required_attachment)
          .map((ts) => {
            return ts.task_id;
          })
      );
      await setRequiredAttachmentList(reqAttList);
      await setShowRequiredAttachment(true);
    }
  };
  const onCloseRequiredAttachment = () => {
    setShowRequiredAttachment(false);
    setCheckedRequiredAttechTaskList([]);
  };
  const onTaskSelect = (taskId) => {
    setCheckedTaskList(taskId);
  };

  const onRequiredAttechTaskSelect = (taskId) => {
    setCheckedRequiredAttechTaskList(taskId);
  };
  const resetCheckList = async () => {
    let selectedtask = customTasksList.customTasks
      .filter((a) => a.task_status === "pending")
      .flatMap((t) => {
        return [
          {
            task_id: t.task.task_id,
            task_type: t.task.task_type,
            task_date: t.task_date,
            required_attachment: t.required_attachment,
          },
        ];
      })
      .filter((a) => !!a);

    let assignedTask = await assignedTasks?.user_tasks_map
      .map(({ task }) => {
        return task;
      })
      .filter((a) => a.is_custom === true)
      .flatMap(({ task_id }) => task_id);

    setCheckedTaskList(assignedTask);

    let response = await ASSIGN_TASK_MUTATION({
      variables: {
        tasks: selectedtask,
        user_id: selectedEmployeeData.user_id,
      },
    });
    if (response?.data?.assign_task) {
      message.success(response.data.assign_task.message);
    }
  };
  const onViewDeails = (user_task_id) => {
    setUserTaskId(user_task_id);
    setShowQrDrawer(true);
  };
  return (
    <section className="taskManagementSec">
      <div className="secSubTitle">
        <div className="stLeft">
          <h5>Assign task to your employees</h5>
        </div>
        <div className="stRight">
          <TaksGuideModal />
        </div>
      </div>
      <div className="taskManagement_blk">
        <Card className="taskManagementCard">
          <div className="taskFilter">
            <div className="selectEmployee">
              <div className="selectEmployeeBtn" onClick={toggleSelectEmployee}>
                Select Employee
              </div>
            </div>
            <Form name="control-ref" onFinish={onRequiredAttachment}>
              <Tooltip
                trigger={["focus"]}
                title={"All Locations"}
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Select
                  showSearch
                  placeholder="All Locations"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  className={`allLocationSelect mr-3`}
                  onChange={(e) => {
                    setSelectedLocation(e);
                  }}
                >
                  <Option value={undefined}>All</Option>
                  {allLocations.map((loc, index) => {
                    return (
                      <Option
                        key={index}
                        value={loc.locationDetails.location_id}
                      >
                        {loc.locationDetails.location_name}
                      </Option>
                    );
                  })}
                </Select>
              </Tooltip>
              <Tooltip
                trigger={["focus"]}
                title={"All Roles"}
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="All Roles"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  className={`allRoleSelect`}
                  onChange={(e) => {
                    setSelectedRole(e);
                  }}
                >
                  <option value={undefined}>All</option>
                  {allRoles.map((role, index) => {
                    return (
                      <Option key={index} value={role.jobRoleDetails.role_id}>
                        {role.jobRoleDetails.role_name}
                      </Option>
                    );
                  })}
                </Select>
              </Tooltip>
            </Form>
          </div>
          <div className="taskManagementRow">
            <div
              className={`listOfEmployeeOverlay ${
                isSelectEmployee ? "open" : ""
              }`}
              onClick={toggleSelectEmployee}
            ></div>
            <div className={`listOfEmployee ${isSelectEmployee ? "open" : ""}`}>
              {isUsersLoading ? (
                <Loader />
              ) : employeeData.length > 0 ? (
                <List
                  size="small"
                  bordered
                  // dataSource={data}
                  // renderItem={item => <List.Item>{item}</List.Item>}
                >
                  {employeeData.map((data, index) => {
                    return (
                      <List.Item
                        key={index}
                        className={`teskEmployee ${
                          selectedEmployeeData.user_id === data.user_id
                            ? "active"
                            : ""
                        }`}
                        onClick={() => toggleEmployeeTask(data)}
                      >
                        <div className="d-flex justify-content-between w-100">
                          <div className="employeeName">
                            {data.first_name + " " + data.last_name}
                          </div>
                          <div className="employeeLocaton">
                            <CustIcon type="location" className="mr-2" />
                            <span>{data.location_name}</span>
                          </div>
                        </div>
                        <div className="employeeRole">{data.role_name}</div>
                      </List.Item>
                    );
                  })}
                </List>
              ) : (
                <Empty
                  image={Empty_EscalationVector}
                  description="Yay! You can check all the escalated tasks of your employees, here. Keep an eye on this!"
                />
              )}
            </div>
            <div className="taskManagementList">
              <div className="secSubTitle">
                {Object.keys(selectedEmployeeData).length > 0 && (
                  <div className="stLeft">
                    <h5>
                      Assign task to{" "}
                      {selectedEmployeeData.first_name +
                        " " +
                        selectedEmployeeData.last_name}
                    </h5>
                  </div>
                )}
                {employeeData.length > 0 && (
                  <div className="">
                    <div className="d-flex align-items-center">
                      <Button
                        shape="round"
                        icon={<CustIcon type="plus" className="mr-2" />}
                        className="d-flex align-items-center addNewEmployee h-auto mr-5"
                        size="large"
                        onClick={() =>
                          customTasksList?.customTasks.reduce(
                            (count, current) => {
                              return (
                                count +
                                (current.task_status === "pending" ? 1 : 0)
                              );
                            },
                            0
                          ) < permission.allow_custom_task
                            ? history.push(
                                `/employee/${selectedEmployeeData.user_id}/tasks`
                              )
                            : setShowUpgradePlanModal(true)
                        }
                      >
                        Add custom task
                      </Button>

                      <span
                        className="text-secondary cursor-pointer"
                        onClick={() => resetCheckList()}
                      >
                        Reset
                      </span>
                      <span className="px-3 text-muted">|</span>
                      <span
                        className="text-primary cursor-pointer"
                        disabled={isAssigningTasks}
                        onClick={() => onRequiredAttachment()}
                      >
                        Save
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className="taskManagementList_blk">
                {customTasksLoading ||
                assignedTasksLoading ||
                roleTasksLoading ||
                isUsersLoading ||
                loading ? (
                  <Loader className="managetaskListLoader" />
                ) : (customTasksList &&
                    customTasksList.customTasks.length > 0) ||
                  (roleTasks && roleTasks.tasks.length > 0) ? (
                  <Checkbox.Group
                    className="w-100"
                    value={checkedTaskList}
                    onChange={onTaskSelect}
                    disabled={isAssigningTasks}
                  >
                    {customTasksList &&
                      customTasksList.customTasks.map(
                        (
                          { task: singleTask, task_date, user_task_id },
                          index
                        ) => {
                          return (
                            <Card key={index}>
                              <div className=" d-flex">
                                <div className="">
                                  <span>
                                    {moment(task_date, "YYYY-MM-DD").format(
                                      "MM-DD-YYYY"
                                    )}
                                  </span>
                                  {/* <span className="px-3 text-muted">|</span> */}
                                </div>

                                <div className="ml-auto">
                                  <div
                                    className={`tagStatus ${singleTask.taskTypeByTaskType.type}`}
                                  >
                                    {/* .reminder .duringDay .endOfDay .timeSensitive */}
                                    {singleTask.taskTypeByTaskType.type_name}
                                  </div>
                                </div>
                              </div>
                              <Checkbox
                                disabled
                                // value=""
                                value={singleTask.task_id}
                              >
                                {singleTask.description}
                              </Checkbox>
                              <div className=" d-flex">
                                <div className="ml-auto">
                                  <div
                                    className="viewDetails"
                                    onClick={() => onViewDeails(user_task_id)}
                                  >
                                    View Details
                                  </div>
                                </div>
                              </div>
                            </Card>
                          );
                        }
                      )}
                    {sortedTasks &&
                      sortedTasks.map((singleTask, index) => {
                        return (
                          <Card key={index}>
                            <div className=" d-flex justify-content-end">
                              <div
                                className={`tagStatus ${singleTask.taskTypeByTaskType.type}`}
                              >
                                {/* .reminder .duringDay .endOfDay .timeSensitive */}
                                {singleTask.taskTypeByTaskType.type_name}
                              </div>
                            </div>
                            <Checkbox checked={true} value={singleTask.task_id}>
                              {singleTask.description}
                            </Checkbox>
                            {!!getNearTask(singleTask.user_tasks_maps) && (
                              <div className=" d-flex">
                                <div className="ml-auto">
                                  <div
                                    className="viewDetails"
                                    onClick={() =>
                                      onViewDeails(
                                        getNearTask(singleTask.user_tasks_maps)
                                      )
                                    }
                                  >
                                    View Details
                                  </div>
                                </div>
                              </div>
                            )}
                          </Card>
                        );
                      })}
                  </Checkbox.Group>
                ) : (
                  <Empty
                    image={Empty_SendFirstAnnouncement}
                    description="No Task"
                    className="mb-5"
                  />
                )}
              </div>
            </div>
          </div>
        </Card>
      </div>
      {showQrDrawer && (
        <TaskQrCodeModal
          userPermission={permission.allow_qr_code}
          userTaskId={userTaskId}
          showQrDrawer={showQrDrawer}
          setShowQrDrawer={setShowQrDrawer}
        />
      )}
      {showRequiredAttachment && (
        <Drawer
          placement="right"
          closable={false}
          width={720}
          maskStyle={{ backgroundColor: "#000000CC" }}
          title="Check all the tasks which require a proof of completion (for e.g a picture) at the time of completing the task by the employee."
          onClose={onCloseRequiredAttachment}
          visible={showRequiredAttachment}
        >
          <div className="d-flex p-3 flex-column ">
            <div className="taskRequiredAttachment">
              <Checkbox.Group
                value={checkedRequiredAttechTaskList}
                onChange={onRequiredAttechTaskSelect}
              >
                {requiredAttachmentList.map((task, index) => {
                  return (
                    <Card key={index} className="mb-2 requiredAttachmentList">
                      <div className="d-flex">
                        <div className="ml-auto">
                          <div className={`tagStatus ${task.task_type}`}>
                            {task.type_name}
                          </div>
                        </div>
                      </div>
                      <Checkbox key={index} value={task.task_id}>
                        {task.description}
                      </Checkbox>
                    </Card>
                  );
                })}
              </Checkbox.Group>
              <div className="taskRequiredAttachmentAction p-4 text-center">
                <Button
                  type="default"
                  shape="round"
                  size="large"
                  className="h-auto"
                  onClick={onCloseRequiredAttachment}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  className="h-auto ml-3"
                  loading={isAssigningRequiredAttachment}
                  onClick={onFinish}
                >
                  Assign
                </Button>
              </div>
            </div>
          </div>
        </Drawer>
      )}
      {showUpgradePlanModal && (
        <UpgradePlanModal
          showUpgradePlanModal={showUpgradePlanModal}
          setShowUpgradePlanModal={setShowUpgradePlanModal}
        />
      )}
    </section>
  );
};
